var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-img',{staticClass:"ma-auto",attrs:{"src":("" + _vm.image),"max-height":"400","max-width":"300"}}),_c('v-row',{staticClass:"pa-10",attrs:{"justify":"center"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }